import React, { useState } from "react";
import { API_URL } from "../config";
import { useI18n } from "../i18n/I18nProvider";
import { SectionTitle } from "../i18n/SectionTitle";

function Contact() {
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const isFormValid = name && email && phone && subject && message;

  const handleChange = (e) => {
    const { name: field, value } = e.target;
    if (field === "name") setName(value);
    if (field === "email") setEmail(value);
    if (field === "phone") setPhone(value);
    if (field === "subject") setSubject(value);
    if (field === "message") setMessage(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      setError(t("contact.allRequired"));
      return;
    }

    setError("");
    setSuccess("");
    setLoading(true);

    const formData = { name, email, phone, subject, message };

    try {
      const response = await fetch(`${API_URL}/api/contact/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      let data;
      try {
        data = await response.json();
      } catch {
        data = {};
      }

      if (response.ok && data.success) {
        setSuccess(data.message || t("contact.successDefault"));
        setName("");
        setEmail("");
        setPhone("");
        setSubject("");
        setMessage("");
      } else {
        setError(data.message || t("contact.failSend"));
      }
    } catch (err) {
      console.log("Fetch error:", err);
      setError(t("contact.failNetwork"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page-modern">
      {loading && (
        <div className="contact-page-modern__overlay">
          <div className="contact-page-modern__spinner" aria-live="polite">
            {t("contact.overlayWait")}
          </div>
        </div>
      )}

      <section className="contact_section layout_padding contact-page-modern__section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-xl-12">
              <SectionTitle
                beforeKey="contact.title"
                afterKey="contact.titleAccent"
                className="contact_taital"
              />

              <div className="row contact-page-modern__grid align-items-start">
                <div className="col-lg-4 mb-4 mb-lg-0">
                  <div className="contact-page-modern__aside">
                    <p className="contact-page-modern__aside-title">
                      {t("contact.direct")}
                    </p>
                    <a
                      href="mailto:abdenacer1993@gmail.com"
                      className="contact-page-modern__link-card"
                    >
                      <span className="contact-page-modern__link-icon" aria-hidden>
                        <i className="fa fa-envelope" />
                      </span>
                      <span className="contact-page-modern__link-body">
                        <span className="contact-page-modern__link-label">
                          {t("contact.emailLabel")}
                        </span>
                        <span className="contact-page-modern__link-value">
                          abdenacer1993@gmail.com
                        </span>
                      </span>
                    </a>
                    <a
                      href="tel:+21624587616"
                      className="contact-page-modern__link-card"
                    >
                      <span className="contact-page-modern__link-icon" aria-hidden>
                        <i className="fa fa-phone" />
                      </span>
                      <span className="contact-page-modern__link-body">
                        <span className="contact-page-modern__link-label">
                          {t("contact.phoneLabel")}
                        </span>
                        <span className="contact-page-modern__link-value">
                          +216 24 587 616
                        </span>
                      </span>
                    </a>
                  </div>
                </div>

                <div className="col-lg-8">
                  <form
                    className="contact-page-modern__form"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <p className="contact-page-modern__form-title">
                      {t("contact.formTitle")}
                    </p>
                    <div className="contact-page-modern__fields">
                      <input
                        type="text"
                        className="contact-page-modern__input"
                        placeholder={t("contact.placeholderName")}
                        name="name"
                        value={name}
                        onChange={handleChange}
                        autoComplete="name"
                        required
                      />
                      <input
                        type="email"
                        className="contact-page-modern__input"
                        placeholder={t("contact.placeholderEmail")}
                        name="email"
                        value={email}
                        onChange={handleChange}
                        autoComplete="email"
                        required
                      />
                      <input
                        type="tel"
                        className="contact-page-modern__input"
                        placeholder={t("contact.placeholderPhone")}
                        name="phone"
                        value={phone}
                        onChange={handleChange}
                        autoComplete="tel"
                        required
                      />
                      <input
                        type="text"
                        className="contact-page-modern__input"
                        placeholder={t("contact.placeholderSubject")}
                        name="subject"
                        value={subject}
                        onChange={handleChange}
                        required
                      />
                      <textarea
                        className="contact-page-modern__textarea"
                        placeholder={t("contact.placeholderMessage")}
                        rows={5}
                        name="message"
                        value={message}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {error && (
                      <p className="contact-page-modern__msg contact-page-modern__msg--error">
                        {error}
                      </p>
                    )}
                    {success && (
                      <p className="contact-page-modern__msg contact-page-modern__msg--success">
                        {success}
                      </p>
                    )}

                    <button
                      type="submit"
                      className="contact-page-modern__submit pro-btn pro-btn--primary"
                      disabled={loading}
                    >
                      {loading ? t("contact.sending") : t("contact.send")}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-page-modern__cta">
        <div className="container">
          <div className="contact-page-modern__cta-inner">
            <div className="contact-page-modern__cta-row">
              <h2 className="contact-page-modern__cta-title">{t("contact.hire")}</h2>
              <a
                href="tel:+21624587616"
                className="contact-page-modern__cta-btn pro-btn pro-btn--primary"
              >
                {t("contact.callNow")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
